import React from 'react'
import { useMsal } from '@azure/msal-react'
import { Navigate, useLocation } from 'react-router-dom'

interface ProtectedRouteProps {
  children: React.ReactElement
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { instance, accounts, inProgress } = useMsal()
  const location = useLocation()
  const account = instance.getActiveAccount() || accounts[0]

  // Avoid redirect loop while MSAL is still handling redirect/login
  if (!account && inProgress !== 'none') {
    return <div className="container py-4">Authenticating...</div>
  }

  if (!account) {
    return <Navigate to="/signin" replace state={{ from: location }} />
  }
  return children
}

export default ProtectedRoute
